"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewMode = void 0;
let SearchPreviewMode = exports.SearchPreviewMode = /*#__PURE__*/function (SearchPreviewMode) {
  SearchPreviewMode["Results"] = "results";
  SearchPreviewMode["Popular"] = "popular";
  return SearchPreviewMode;
}({});
